<template>
    <div v-if="isVisible">
        <div class="pl-4 pt-3 pb-4">
            <h5>Damage claim details</h5>
        </div>
        <v-row no-gutters>
            <v-col cols="12" class="px-2">
                <v-data-table dense 
                    :headers="getHeaders()" 
                    :items="hsmr" 
                    :disable-pagination=true 
                    hide-default-footer
                    item-key="hsmr_encrid">
                    <template v-slot:item="hsmr">
                        <tr>
                            <td class="row-default">{{ $moment(hsmr.item.hsmr_dt).format("DD-MM-YYYY HH:mm") }}</td>
                            <td class="row-default">{{ hsmr.item.hsmr_oms }}</td>
                            <td class="row-default">{{ hsmr.item.hsmr_smst_display }}</td>
                            <td class="row-default">{{ hsmr.item.gebr_naam }}</td>
                            <td class="row-default"><v-btn x-small text icon v-on:click="updHsmr(hsmr.item.hsmr_encrid)"><v-icon small>mdi-wrench</v-icon></v-btn></td>
                            <td class="row-default">
                                <span v-if="hsmr.item.can_delete">
                                    <v-btn x-small text icon v-on:click="rmHsmr(hsmr.item.hsmr_encrid)"><v-icon small>mdi-trash-can-outline</v-icon></v-btn>
                                </span>
                                <span v-else>
                                    <v-btn x-small text icon disabled><v-icon small></v-icon></v-btn>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <v-row dense>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small text icon v-bind="attrs" v-on="on"
                           v-on:click="addHsmr()"
                           class="mr-7 mb-2 gridbutton"><v-icon small>mdi-plus</v-icon>
                    </v-btn>
                </template>
                <span>Add new event for {{ this.key }} </span>
            </v-tooltip>                
        </v-row>        
        <updHsmr ref="updHsmr" :claim_description="claim_description" @updateData="updateData"></updHsmr>
    </div>
</template>

<script>

    import updHsmr from '@/components/huov/hosm/updHsmr.vue';

    export default {
        props: {
            isVisible: {
                type: Boolean,
                default: false
            },
            claim_description: String,
        },
        components: {
            updHsmr,
        },
        data() {
            return {
                key: '',
                hosm_encrid: '',                
                hsmr: [],
            }
        },
        methods: {
            open(hosm_encrid, key) {
                console.log('open', key);
                this.key = key  
                this.hosm_encrid = hosm_encrid                
                this.$emit('updateField', { field: 'showDetails', value: !this.isVisible });
                if (!this.isVisible) {
                    this.getHsmr(hosm_encrid);
                }
            },
            getHsmr(hosm_encrid) {
                this.$axios
                    .post("ares/json/ares/huov/hosm/getHsmr.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "getHsmr"
                        },
                        getHsmr: {
                            hosm_encrid: hosm_encrid,
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.hsmr = res.data.hosm_hsmr;
                        }
                    });
            },
            updHsmr(hsmr_encrid) {
                this.$refs.updHsmr.open(hsmr_encrid);
            },
            addHsmr(){
                this.$emit('executeFunction',  [
                    {field: 'function', value: 'add_claim_event'},  
                    {field: 'encrid', value: this.hosm_encrid},  
                    {field: 'key', value: this.key}
                ]);
            },              
            rmHsmr(hsmr_encrid) {
                this.$axios
                    .post("ares/json/ares/huov/hosm/rmHsmr.p", {
                        header: {
                            token: this.$session.get("ARES"),
                            clientSessionId: this.$session.id(),
                            request: "rmHsmr"
                        },
                        rmHsmr: {
                            hsmr_encrid: hsmr_encrid
                        }
                    })
                    .then(res => {
                        if (res.data.error) {
                            console.log(res.data.error);
                        } else {
                            this.updateData();
                        }
                    });
            },
            updateData() {
                this.$emit('updateData', 'refresh');
            },
            getHeaders() {
                return [
                    { text: "Date/time", sortable: false, width: "18%" },
                    { text: "Description", sortable: false, width: "50%" },
                    { text: "Status", sortable: false, width: "20%" },
                    { text: "User", sortable: false, width: "20%"},
                    { sortable: false, align: "start", width: "5%" },                    
                    { sortable: false, align: "start", width: "5%" },
                ];
            },
        }
    }
</script>

<style scoped>
.row-default {
    cursor: default;
    vertical-align: top;
    border-top: 5px solid transparent;    
    font-size: 14px !important;    
}
.gridbutton{
    border: 1px solid rgba(169, 169, 169, 1) !important;
}
</style>
